export default __webpack_public_path__ + "static/media/offerzen-logo.92c8a0315a30afc10f23789053101a4b.svg";